import { Routes } from '@angular/router';
import { authGuard, noAuthGuard } from './core/auth/auth.guard';
import { LoginComponent } from './features/login/login.component';
import { AuthCallbackComponent } from './features/auth-callback/auth-callback.component';

export const routes: Routes = [
  // SSO redirect after successful login
  {
    path: 'sso-redirect',
    component: AuthCallbackComponent
  },
  
  // Login stranka - spracovava aj OAuth callback
  {
    path: 'login',
    component: LoginComponent
    // Odstraneny noAuthGuard - tato stranka spracovava aj callback
  },
  
  // Login with specific provider (e.g., /login/ardaco)
  {
    path: 'login/:provider',
    component: LoginComponent
  },
  
  // OAuth callback URL - fallback
  {
    path: 'auth/callback',
    component: AuthCallbackComponent
  },
  
  // Root - presmeruje na login ak nie je prihlaseny, inak zostane na hlavnej stranke
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ''
  }
];
